import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory as createHistory } from 'history';
import { createLogger } from 'redux-logger';

const history = createHistory();

const devMiddleware = [
	// thunk middleware can also accept an extra argument to be passed to each thunk action
	// https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
	// thunk.withExtraArgument(thunkExtraArguments),
	thunk,
];

if (process.env.REDUX_LOG === undefined) {
	devMiddleware.push(
		// must come after thunks to avoid undefined action dispatches
		// Redux action logging
		createLogger({ collapsed: true })
	);
}

type Options = {
	middleware?: any[];
};

function configureStoreDev(initialState, reducer, options: Options = {}) {
	const middlewareMap = {
		dev: devMiddleware,
		prod: [thunk],
	};
	const isDev = process.env.NODE_ENV === 'development';
	const middleware = isDev ? middlewareMap.dev : middlewareMap.prod;

	if (options.middleware) {
		middleware.push(...options.middleware);
	}

	// add support for Redux dev tools:
	const composeEnhancers =
		(window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.({
			actionsBlacklist: ['@@redux-form/UNREGISTER_FIELD', '@@redux-form/REGISTER_FIELD'],
		}) || compose;
	const store = createStore(reducer, initialState, composeEnhancers(applyMiddleware(...middleware)));

	(window as any).store = store;

	// @ts-expect-error ts-migrate FIXME
	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		// @ts-expect-error ts-migrate FIXME
		module.hot.accept('./reducers', () => {
			const nextReducer = require('./reducers').default; // eslint-disable-line global-require
			store.replaceReducer(nextReducer);
		});
	}

	return store;
}

export { history };

// @todo create a production configure store function
export default configureStoreDev;
